export default [
    {
        id: 1,
        level: 'Risk',
        bgColor: '#be3144',
        title: 'Long Event',
        type: 'event',
        start: new Date(2024, 3, 29),
        end: new Date(2024, 3, 29)
    },

    {
        id: 2,
        level: 'Risk',
        bgColor: '#007876',
        title: 'DTS STARTS',
        type: 'event',
        start: new Date(2024, 3, 13),
        end: new Date(2024, 3, 20)
    },

    {
        id: 3,
        type: 'event',
        level: 'Risk',
        bgColor: '#3371ff',
        title: 'DTS ENDS',
        start: new Date(2024, 10, 6),
        end: new Date(2024, 10, 13)
    },

    {
        id: 4,
        type: 'event',
        level: 'Risk',
        bgColor: '#f19e38',
        title: 'Some Event',
        start: new Date(2024, 3, 9),
        end: new Date(2024, 3, 9),
        allDay: true
    },

    {
        id: 92,
        type: 'meeting',
        level: 'Risk',
        bgColor: 'orange',
        title: 'Some Other Event',
        start: new Date(2024, 3, 9, 8, 0),
        end: new Date(2024, 3, 9, 11, 30, 0)
    },
    {
        id: 5,
        type: 'event',
        level: 'Risk',
        bgColor: '#4b0082',
        title: 'Conference',
        start: new Date(2024, 3, 11),
        end: new Date(2024, 3, 13),
        desc: 'Big conference for important people'
    },
    {
        id: 6,
        level: 'Risk',
        bgColor: '#444444',
        title: 'Meeting',
        type: 'meeting',
        start: new Date(2024, 3, 12, 10, 30, 0, 0),
        end: new Date(2024, 3, 12, 12, 30, 0, 0),
        desc: 'Pre-meeting meeting, to prepare for the meeting'
    },
    {
        id: 7,
        type: 'meeting',
        level: 'Risk',
        bgColor: '#007876',
        title: 'Lunch',
        start: new Date(2024, 3, 12, 12),
        end: new Date(2024, 3, 12, 13),
        desc: 'Power lunch'
    },
    {
        id: 8,
        type: 'meeting',
        level: 'Risk',
        bgColor: '#be3144',
        title: 'Meeting',
        start: new Date(2024, 3, 12, 14),
        end: new Date(2024, 3, 12, 15)
    },
    {
        id: 9,
        type: 'meeting',
        level: 'Risk',
        bgColor: '#3371ff',
        title: 'Happy Hour',
        start: new Date(2024, 3, 12, 17),
        end: new Date(2024, 3, 12, 17, 30, 0, 0),
        desc: 'Most important meal of the day'
    },
    {
        id: 10,
        type: 'meeting',
        level: 'Risk',
        bgColor: 'orange',
        title: 'Dinner',
        start: new Date(2024, 3, 12, 20),
        end: new Date(2024, 3, 12, 21)
    },
    {
        id: 11,
        type: 'meeting',
        level: 'Risk',
        bgColor: '#3371ff',
        title: 'Planning Meeting with Paige',
        start: new Date(2024, 3, 13, 8, 0, 0),
        end: new Date(2024, 3, 13, 10, 30, 0)
    },
    {
        id: 11.1,
        type: 'meeting',
        level: 'Risk',
        bgColor: '#f19e38',
        title: 'Inconvenient Conference Call',
        start: new Date(2024, 3, 13, 9, 30, 0),
        end: new Date(2024, 3, 13, 12, 0, 0)
    },
    {
        id: 11.2,
        type: 'meeting',
        level: 'Risk',
        bgColor: '#4b0082',
        title: "Project Kickoff - Lou's Shoes",
        start: new Date(2024, 3, 13, 11, 30, 0),
        end: new Date(2024, 3, 13, 14, 0, 0)
    },
    {
        id: 11.3,
        type: 'meeting',
        level: 'Risk',
        bgColor: '#be3144',
        title: 'Quote Follow-up - Tea by Tina',
        start: new Date(2024, 3, 13, 15, 30, 0),
        end: new Date(2024, 3, 13, 16, 0, 0)
    },
    {
        id: 12,
        type: 'event',
        level: 'Risk',
        bgColor: '#3371ff',
        title: 'Late Night Event',
        start: new Date(2024, 3, 17, 19, 30, 0),
        end: new Date(2024, 3, 18, 2, 0, 0)
    },
    {
        id: 12.5,
        type: 'meeting',
        level: 'Risk',
        bgColor: 'pink',
        title: 'Late Same Night Event',
        start: new Date(2024, 3, 17, 19, 30, 0),
        end: new Date(2024, 3, 17, 23, 30, 0)
    },
    {
        id: 12.5,
        type: 'meeting',
        level: 'Risk',
        bgColor: '#444444',
        title: 'Late Same Night Event',
        start: new Date(2024, 3, 17, 5, 0, 0),
        end: new Date(2024, 3, 17, 6, 0, 0)
    },
    {
        id: 12.5,
        type: 'meeting',
        level: 'Risk',
        bgColor: 'darkGrey',
        title: 'Late Same Night Event',
        start: new Date(2024, 3, 17, 5, 0, 0),
        end: new Date(2024, 3, 17, 6, 0, 0)
    },
    {
        id: 13,
        level: 'Risk',
        bgColor: '#1b81b3',
        title: 'Multi-day Event',
        type: 'event',
        start: new Date(2024, 3, 20, 19, 30, 0),
        end: new Date(2024, 3, 22, 2, 0, 0)
    },
    {
        id: 14,
        level: 'Risk',
        bgColor: 'linear-gradient(60deg, hsl(var(--primary-foreground)) 10%, hsl(var(--primary-thick-foreground)) 10%, hsl(var(--primary-foreground)) 20%, hsl(var(--primary-thick-foreground)) 20%, hsl(var(--primary-foreground)) 30%, hsl(var(--primary-thick-foreground)) 30%, hsl(var(--primary-foreground)) 40%, hsl(var(--primary-thick-foreground)) 40%, hsl(var(--primary-foreground)) 50%, hsl(var(--primary-thick-foreground)) 50%, hsl(var(--primary-foreground)) 60%, hsl(var(--primary-thick-foreground)) 60%, hsl(var(--primary-foreground)) 70%, hsl(var(--primary-thick-foreground)) 70%, hsl(var(--primary-foreground)) 80%, hsl(var(--primary-thick-foreground)) 80%, hsl(var(--primary-foreground)) 90%, hsl(var(--primary-thick-foreground)) 90%, hsl(var(--primary-foreground)) 100%, hsl(var(--primary-thick-foreground)) 100%)',
        title: 'Today',
        type: 'holiday',
        start: new Date('2024-6-4'),
        end: new Date('2024-6-4')
    },
    {
        id: 14,
        // level: 'Risk',
        // bgColor: '#00a2a1',
        title: 'holiday',
        // type: 'event',
        // start: new Date(new Date().setHours(new Date().getHours() - 3)),
        end: new Date(new Date().setHours(new Date().getHours() + 3))
    },
    {
        id: 16,
        type: 'meeting',
        level: 'Risk',
        bgColor: 'palevioletred',
        title: 'Video Record',
        start: new Date(2024, 3, 14, 15, 30, 0),
        end: new Date(2024, 3, 14, 19, 0, 0)
    },
    {
        id: 17,
        type: 'meeting',
        level: 'Risk',
        bgColor: '#4b0082',
        title: 'Dutch Song Producing',
        start: new Date(2024, 3, 14, 16, 30, 0),
        end: new Date(2024, 3, 14, 20, 0, 0)
    },
    {
        id: 18,
        level: 'Risk',
        bgColor: 'brown',
        title: 'Itaewon Meeting',
        type: 'meeting',
        start: new Date(2024, 3, 14, 16, 30, 0),
        end: new Date(2024, 3, 14, 17, 30, 0)
    },
    {
        id: 19,
        type: 'meeting',
        level: 'Risk',
        bgColor: 'pink',
        title: 'Online Coding Test',
        start: new Date(2024, 3, 14, 17, 30, 0),
        end: new Date(2024, 3, 14, 20, 30, 0)
    },
    {
        id: 24,
        type: 'event',
        level: 'Risk',
        bgColor: '#f19e38',
        title: 'DST ends on this day (Europe)',
        start: new Date(2024, 9, 30),
        end: new Date(2024, 9, 30)
    },
    {
        id: 25,
        type: 'event',
        level: 'Risk',
        bgColor: '#4b0082',
        title: 'DST ends on this day (America)',
        start: new Date(2024, 10, 6),
        end: new Date(2024, 10, 6)
    },
    {
        id: 26,
        type: 'event',
        level: 'Risk',
        bgColor: 'orange',
        title: 'DST starts on this day (America)',
        start: new Date(2024, 2, 12),
        end: new Date(2024, 2, 12)
    },
    {
        id: 27,
        type: 'event',
        level: 'Risk',
        bgColor: '#3371ff',
        title: 'DST starts on this day (Europe)',
        start: new Date(2024, 2, 26),
        end: new Date(2024, 2, 26)
    }
]
